export default __webpack_public_path__ + "static/media/DUB-CIRCLE.ba87877d.png";